import { Link, Navigate, useParams } from "react-router-dom";
import {
  useAcceptCommunityRequest,
  useCommunity,
  useRejectCommunityRequest,
} from "../hooks/useCommunity";
import useUserStore from "../store/userStore";
import "./CommunityDetails.css";

const ManageCommunity = () => {
  const { id } = useParams();
  const communityId = Number(id);
  const token = useUserStore((state) => state.token);
  const username = useUserStore((state) => state.username);
  const { data: community, isLoading, error } = useCommunity(communityId);
  const acceptRequest = useAcceptCommunityRequest();
  const rejectRequest = useRejectCommunityRequest();

  if (Number.isNaN(communityId)) {
    return <div className="community-detail-page">Community not found.</div>;
  }

  if (isLoading) {
    return <div className="community-detail-page">Loading community...</div>;
  }

  if (error || !community) {
    return <div className="community-detail-page">Community not found.</div>;
  }

  if (community.owner?.username !== username) {
    return <Navigate to={`/community/${community.id}`} replace />;
  }

  const pendingRequests = community.requests ?? [];
  const members = community.members ?? [];
  const isWorking = acceptRequest.isPending || rejectRequest.isPending;

  return (
    <main className="community-detail-page">
      <section className="community-detail-section">
        <Link className="community-detail-back" to={`/community/${community.id}`}>
          Back to community
        </Link>
        <div className="community-manage-header">
          <div>
            <h1>Manage {community.name}</h1>
            <p>
              Review join requests and keep track of the trainers in your
              community.
            </p>
          </div>
          <span>{pendingRequests.length} pending</span>
        </div>

        <h2>Join Requests</h2>
        {pendingRequests.length ? (
          <div className="community-request-list">
            {pendingRequests.map((requester) => (
              <div
                className="community-request-row"
                key={requester.id ?? requester.username}
              >
                <Link to={`/profile/${requester.username}`}>
                  {requester.username}
                </Link>
                <div>
                  <button
                    type="button"
                    disabled={isWorking || !requester.id}
                    onClick={() =>
                      requester.id &&
                      acceptRequest.mutate({
                        communityId: community.id as number,
                        requesterId: requester.id,
                        token,
                      })
                    }
                  >
                    Accept
                  </button>
                  <button
                    type="button"
                    className="community-detail-secondary"
                    disabled={isWorking || !requester.id}
                    onClick={() =>
                      requester.id &&
                      rejectRequest.mutate({
                        communityId: community.id as number,
                        requesterId: requester.id,
                        token,
                      })
                    }
                  >
                    Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="community-detail-empty">No pending requests.</p>
        )}
      </section>

      <section className="community-detail-section">
        <h2>Members</h2>
        {members.length ? (
          <div className="community-detail-list">
            {members.map((member) => (
              <Link
                className="community-detail-person"
                key={member.id ?? member.username}
                to={`/profile/${member.username}`}
              >
                {member.username}
              </Link>
            ))}
          </div>
        ) : (
          <p className="community-detail-empty">No members yet.</p>
        )}
      </section>
    </main>
  );
};

export default ManageCommunity;
